export const cache = {
  __cache: {},
  read(src) {
    if (!src) {
      return;
    }

    if (!this.__cache[src]) {
      this.__cache[src] = new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          resolve(img);
        };
        img.src = src;
        // setTimeout(() => resolve({}), 7000);
      });
    }
    return this.__cache[src];
  },
  clearImg: (src) => {
    delete this.__cache[src];
  }
};
const _cache = {};

export const loadImages = async (rateGroups) => {
  const p =  rateGroups.map(item => {
      return new Promise((resolve, reject) => {
        if (!item.icon) return resolve('');
        if (_cache[item.icon]) return resolve(_cache[item.icon]);
          const img = new Image();

          img.src = item.icon;
          img.onload = () => {
            _cache[item.icon] = img;
              resolve(img);
          };
          img.onerror = reject;
      });
  });

  return await Promise.all(p);
}
